(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@tucar/pit-stop", [], factory);
	else if(typeof exports === 'object')
		exports["@tucar/pit-stop"] = factory();
	else
		root["@tucar/pit-stop"] = factory();
})(self, () => {
return 